import React, {useEffect} from 'react';
import {useState} from 'react';
import {useUploadFileMutation} from '../../../store/builder/inspections.api';
import Input from '../../Input';
import CustomSelect from '../../CustomSelect';
import {toast} from 'react-toastify';
import { useTranslation } from '../../../hooks/useTranslation';

export default function FileField({
  id,
  label,
  setFields,
  equipmentId,
  field,
  files = false,
  fields,
  readOnly,
  onUploadingChange,
}) {
  const [image, setImage] = useState(null);
  const [file, setFile] = useState(null);
  const [multiFiles, setMultiFiles] = useState([]);
  const [isHovering, setIsHovering] = useState(false);
  const [galleryStatus, setGalleryStatus] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState(null);
  const [currentFileType, setCurrentFileType] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [showImage, setShowImage] = useState(null);
  const [showOrphan, setShowOrphan] = useState(false);
  const {t} = useTranslation();

  let guid = () => {
    let s4 = () => {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    };
    return (
      s4() +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      '-' +
      s4() +
      s4() +
      s4()
    );
  };

  const [uploadFile, {data, isSuccess, isLoading, isError}] =
    useUploadFileMutation();

  useEffect(() => {
    if (files) {
      if (field.files?.length > 0) {
        setMultiFiles(field.files);
      }
    } else {
      if (field?.file?.filename) {
        setFile(field.file);
      }
    }

    if (field?.key === 'differential_pressure_calibration_image') {
      const values = Array.isArray(field?.value)
        ? field.value
        : field?.value
        ? [field.value]
        : [];
      const hasOrphan = values.some(
        uuid => !field.files?.find(f => f.uuid === uuid),
      );
      if (hasOrphan) setShowOrphan(true);
    }
  }, []);

  useEffect(() => {
    onUploadingChange?.(uploading);
  }, [uploading]);

  useEffect(() => {
    if (galleryStatus) {
      document.querySelector('html').style.overflow = 'hidden';
    } else {
      document.querySelector('html').style.overflow = 'visible';
    }
  }, [galleryStatus]);

  const handleImage = e => {
    setCurrentFileType(
      e?.target?.value?.split('.')[e?.target?.value?.split('.').length - 1],
    );
    const selectedFiles = e.target.files;
    if (field?.key === 'hose_certs') {
      setMultiFiles([]);
      if (
        selectedFiles.length <=
        fields?.filter(el => el.key === 'hose_count')[0]?.value
      ) {
        const selectedFilesArray = Array?.from(selectedFiles);
        const imagesArray = selectedFilesArray.map(file => {
          return {
            file: URL.createObjectURL(file),
            format: file.name.split('.')[file.name.split('.').length - 1],
          };
        });

        if (files) {
          let arrayUUID = [];
          for (let i = 0; i < e.target.files.length; i++) {
            setUploading(true);
            const form = new FormData();
            form.append('file', e.target.files[i]);
            form.append('type', 'equipment');
            form.append('equipment_id', equipmentId ? equipmentId : 0);
            form.append('uuid', guid());
            uploadFile(form).then(res => {
              setUploading(false);
              arrayUUID = [...arrayUUID, res?.data?.data?.uuid];
              setMultiFiles(old => [...old, res?.data?.data]);
              setFields(old => {
                let data = [
                  ...old.map(item => {
                    let newArray = {...item};
                    if (newArray?.key === id) {
                      newArray.value = arrayUUID;
                    }
                    return newArray;
                  }),
                ];
                return data;
              });
            });
          }
        } else {
          const form = new FormData();
          form.append('file', e.target.files[0]);
          form.append('type', 'equipment');
          form.append('equipment_id', equipmentId ? equipmentId : 0);
          form.append('uuid', guid());
          setUploading(true);
          uploadFile(form).then(res => {
            setFile(res?.data?.data);
            setUploading(false);
            setFields(old => {
              let data = [
                ...old.map(item => {
                  let newArray = {...item};
                  if (newArray?.key === id) {
                    newArray.value = res?.data?.data?.uuid;
                  }
                  return newArray;
                }),
              ];
              return data;
            });
          });
        }
      } else if (
        fields?.filter(el => el.key === 'hose_count')[0]?.value === null ||
        fields?.filter(el => el.key === 'hose_count')[0]?.value === undefined
      ) {
        toast.error(`Choose number of hose count`);
      } else {
        toast.error(
          `Maximum number of files: ${fields?.filter(el => el.key === 'hose_count')[0]?.value}`,
        );
      }
    } else {
      const selectedFilesArray = Array?.from(selectedFiles);
      const imagesArray = selectedFilesArray.map(file => {
        return URL.createObjectURL(file);
      });

      if (files) {
        const initialValue = Array.isArray(field?.value)
          ? field.value
          : field?.value
          ? [field.value]
          : [];
        let arrayUUID = [];
        for (let i = 0; i < e.target.files.length; i++) {
          setUploading(true);
          const form = new FormData();
          form.append('file', e.target.files[i]);
          form.append('type', 'equipment');
          form.append('equipment_id', equipmentId ? equipmentId : 0);
          form.append('uuid', guid());
          uploadFile(form).then(res => {
            setUploading(false);
            setMultiFiles(old => [...old, res?.data?.data]);
            arrayUUID = [...arrayUUID, res?.data?.data?.uuid];
            const uploadedFile = res?.data?.data;
            setFields(old => {
              let data = [
                ...old.map(item => {
                  let newArray = {...item};
                  if (newArray?.key === id) {
                    newArray.value = [
                      ...initialValue.filter(v => !arrayUUID.includes(v)),
                      ...arrayUUID,
                    ];
                    if (uploadedFile) {
                      const existingFiles = newArray.files || [];
                      if (!existingFiles.find(f => f.uuid === uploadedFile.uuid)) {
                        newArray.files = [...existingFiles, uploadedFile];
                      }
                    }
                  }
                  return newArray;
                }),
              ];
              return data;
            });
          });
        }
      } else {
        const form = new FormData();
        form.append('file', e.target.files[0]);
        form.append('type', 'equipment');
        form.append('equipment_id', equipmentId ? equipmentId : 0);
        form.append('uuid', guid());
        setUploading(true);
        uploadFile(form).then(res => {
          setFields(old => {
            setUploading(false);
            setFile(res?.data?.data);
            let data = [
              ...old.map(item => {
                let newArray = {...item};
                if (newArray?.key === id) {
                  newArray.value = res?.data?.data?.uuid;
                }
                return newArray;
              }),
            ];
            return data;
          });
        });
      }
    }
  };

  const cleanFile = (type, uuid) => {
    if (type === 'file') {
      setFile(null);
      setFields(old => {
        let data = [
          ...old.map(item => {
            let newArray = {...item};
            if (newArray?.key === id) {
              newArray.value = null;
            }
            return newArray;
          }),
        ];
        return data;
      });
    } else if (type === 'files') {
      setMultiFiles(old => old.filter(el => el.uuid !== uuid));
      setFields(old => {
        let data = [
          ...old.map(item => {
            let newArray = {...item};
            if (newArray?.key === id) {
              newArray.value = newArray?.value?.filter(el => el !== uuid);
              newArray.files = newArray?.files?.filter(el => el.uuid !== uuid);
            }
            return newArray;
          }),
        ];
        return data;
      });
    }
  };

  const renderFullPhoto = () => {
    return (
      <div className='modal'>
        <img
          className='modal__gallery-close'
          src='/assets/icons/close.svg'
          alt='close'
          onClick={() => {
            setShowImage(null);
            setGalleryStatus(false);
          }}
        />
        <img className='modal__gallery-photo' src={showImage} alt='photo' />
        <div className='modal__bg'></div>
      </div>
    );
  };

  return (
    <>
      {galleryStatus && renderFullPhoto()}
      <div className='equipment__container'>
        <div className='equipment__file new'>
          <div className='title'>{label}</div>
          <div
            className='file'
            title={readOnly ? t('createEquipment.readOnly') : undefined}
          >
            {/*{isHovering && (*/}
            {/*  <label*/}
            {/*    htmlFor={id}*/}
            {/*    className="file__upload"*/}
            {/*    onMouseOver={() => setIsHovering(true)}*/}
            {/*  >*/}
            {/*    <img src="/assets/icons/upload.svg" alt="upload" />*/}
            {/*  </label>*/}
            {/*)}*/}
            <input
              type='file'
              id={id}
              accept='image/png, image/jpeg, .pdf'
              onChange={handleImage}
              multiple={files}
              readOnly={readOnly}
            />
            {files
              ? (multiFiles?.length > 0 || uploading) &&
                multiFiles?.map((el, idx) => (
                  <div className='equipment__file-preview' key={idx}>
                    <div className='equipment__file-previewTop'>
                      <div
                        className='equipment__file-part pointer'
                        onClick={() => {
                          if (
                            el?.filename?.split('.')[
                              el?.filename?.split('.')?.length - 1
                            ] !== 'pdf'
                          ) {
                            setGalleryStatus(true);
                            setShowImage(el?.url);
                          } else {
                            window.open(el?.url, '_blank');
                          }
                        }}
                      >
                        <img src='/assets/preview-file.svg' alt='preview' />
                        <span className='equipment__file-name'>
                          {el?.filename}
                        </span>
                      </div>
                      <div className='equipment__file-part'>
                        {uploading && (
                          <p className='equipment__file-pending'>
                            Image upload in progress
                          </p>
                        )}
                        {el?.filename && !uploading && (
                          <img
                            className='equipment__file-close'
                            onClick={() => cleanFile('files', el?.uuid)}
                            src='/assets/icons/close.svg'
                            alt='close'
                          />
                        )}
                      </div>
                    </div>
                    {uploading && <div className='loader-line'></div>}
                  </div>
                ))
              : (file?.filename || uploading) && (
                  <div className='equipment__file-preview'>
                    <div className='equipment__file-previewTop'>
                      <div
                        className='equipment__file-part pointer'
                        onClick={() => {
                          if (
                            file?.filename?.split('.')[
                              file?.filename?.split('.')?.length - 1
                            ] !== 'pdf'
                          ) {
                            setGalleryStatus(true);
                            setShowImage(file?.url);
                          } else {
                            window.open(file?.url, '_blank');
                          }
                        }}
                      >
                        <img src='/assets/preview-file.svg' alt='preview' />
                        <span className='equipment__file-name'>
                          {file?.filename}
                        </span>
                      </div>
                      <div className='equipment__file-part'>
                        {uploading && (
                          <p className='equipment__file-pending'>
                            Image upload in progress
                          </p>
                        )}
                        {file?.filename && !uploading && (
                          <img
                            className='equipment__file-close'
                            onClick={() => cleanFile('file', file?.uuid)}
                            src='/assets/icons/close.svg'
                            alt='close'
                          />
                        )}
                      </div>
                    </div>
                    {uploading && <div className='loader-line'></div>}
                  </div>
                )}
            {showOrphan && (
              <div className='equipment__file-preview'>
                <div className='equipment__file-previewTop'>
                  <div className='equipment__file-part'>
                    <span className='equipment__file-name' style={{color: '#e53935'}}>
                      Image unavailable — remove to save
                    </span>
                  </div>
                  <div className='equipment__file-part'>
                    <img
                      className='equipment__file-close'
                      onClick={() => {
                        setShowOrphan(false);
                        setFields(old =>
                          old.map(item =>
                            item?.key === id ? {...item, value: null} : item,
                          ),
                        );
                      }}
                      src='/assets/icons/close.svg'
                      alt='close'
                    />
                  </div>
                </div>
              </div>
            )}
            {!readOnly && (
              <label className='equipment__file-choose' htmlFor={id}>
                <span>
                  <img src='/assets/icons/camera.svg' alt='camera' />
                </span>
                <p>{t('equipmentComponents.fileField.chooseFile')}</p>
              </label>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
